import { VEC_ICON_NAME } from "../../../../../components/icons/constants"

export const REQUEST_TYPE_STATUS = {
    W9REQUEST: "W-9 Request",
    W8REQUEST: "W-8 Request"
}

export const REQUEST_TYPE = [
    { title: REQUEST_TYPE_STATUS.W9REQUEST, icon: VEC_ICON_NAME.PAYER_TYPE_INDIVIDUAL },
    { title: REQUEST_TYPE_STATUS.W8REQUEST, icon: VEC_ICON_NAME.PAYER_TYPE_BUSINESS }
]
